import { render, staticRenderFns } from "./ButtonCopyToClipboard.vue?vue&type=template&id=366fb177"
import script from "./ButtonCopyToClipboard.js?vue&type=script&lang=js&external"
export * from "./ButtonCopyToClipboard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports